import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { LoaderService } from '@core/services/loader.service';
import { Observable } from 'rxjs';
import { filter, finalize } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class HttpSpinnerInterceptor implements HttpInterceptor {
  private loaderService = inject(LoaderService);

  private readonly requests: Array<HttpRequest<unknown>> = [];

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    this.loaderService.show();
    this.requests.push(req);

    return next.handle(req).pipe(
      filter((event) => event instanceof HttpResponse),
      finalize(() => {
        this.onRequestEnd(req);
      })
    );
  }

  private onRequestEnd(req: HttpRequest<unknown>): void {
    const i = this.requests.indexOf(req);

    if (i >= 0) {
      this.requests.splice(i, 1);
    }

    if (!this.requests.length) {
      this.loaderService.hide();
    }
  }
}
